export const SU_API_BASE = '/seller-university/api';
export const SU_API = {
  LEARNING_PATHWAY: `${SU_API_BASE}/learning-pathway`,
  LEARNING_PATHWAY_STATIC: `${SU_API_BASE}/learning-pathway-static`,
  CONTENT_PROGRESS: `${SU_API_BASE}/content-progress`,
  CONTENT_FEEDBACK: `${SU_API_BASE}/content-feedback`,
  LIST_TOPICS: `${SU_API_BASE}/topics`,
  LIST_LEARNING_PATHWAYS: `${SU_API_BASE}/learning-pathways-static`,
  TOPIC: `${SU_API_BASE}/topic`,
  TOPIC_FILTER: `${SU_API_BASE}/topic/filter`,
  LIST_LEARNING_MODULES: `${SU_API_BASE}/modules`,
  LEARNING_MODULE: `${SU_API_BASE}/module`,
  SEARCH: `${SU_API_BASE}/search`,
  AUTOCOMPLETE: `${SU_API_BASE}/autocomplete`,
  AUTOCOMPLETE_V2: `${SU_API_BASE}/autocomplete-v2`,
  LIST_WEBINARS: `${SU_API_BASE}/webinars`,
  REGISTER_WEBINAR: `${SU_API_BASE}/webinar/register`,
  SELLER_CONTEXT: `${SU_API_BASE}/seller-context`,
};
export const API_SEARCH_PARAMS = {
  LEARNING_PATHWAY_ID: 'learningPathwayId',
  CLIENT_ID: 'clientId',
  QUERY: 'query',
  SEARCH_TEXT: 'searchText',
  PAGE_NUMBER: 'pageNumber',
  PAGE_SIZE: 'pageSize',
  MODULE_ID: 'moduleId',
  TOPIC_ID: 'topicId',
  QUERY_TYPE: 'queryType',
  SUBTOPIC_ID: 'subtopicId',
  TAG_ID: 'tagId',
  WEBINAR_CLIENT_ID: 'webinarClientId',
  METADATA_ONLY: 'metadataOnly',
  SEL_LOCALE: 'sel_locale',
};

export const URL_SEARCH_PARAMS = {
  MONS_SEL_LOCALE: 'mons_sel_locale',
};

export const API_DEFAULTS = {
  MARKETPLACE_ID: 'ATVPDKIKX0DER',
  LOCALE: 'en_US',
};

export const WEBINAR_CONFIG = {
  CLIENT_ID: 'bba9ac45-1bd8-4347-81e7-ae09c360d01d',
};

export const AUTOCOMPLETE_PARAM = {
  MAX_RESULTS: 10,
  THROTTLE_MS: 300,
  DISABLED: false,
  ARIA_LABEL: '',
};

export const AUTOCOMPLETE_V2_PARAM = {
  MAX_SUGGESTIONS: 10,
  MAX_MODULES: 2,
  THROTTLE_MS: 300,
  DISABLED: false,
  ARIA_LABEL: '',
};

export const HMD_SURVEY_SUBMIT_URL = '/gp/satisfaction/survey-submit.html';
